// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Select } from '@gandi/ui-select';

import { useAppSelector } from 'src/hooks/useAppSelector';

import type { Option } from '../../../modules/app/selectors/locale';

import { selectShopCurrencies } from './modules/selectors';

type Props = {
  onChange: (option: Option) => void,
  disabled: boolean,
  loading: boolean,
  country: string,
  value: string,
  name: string,
  orgId?: string,
  className?: string,
};

export default function CurrencySelect({
  country,
  disabled,
  loading,
  onChange,
  value,
  orgId,
  name,
  className,
}: Props): React.MixedElement {
  const { formatCurrency } = useTranslator();
  const currencies = useAppSelector(state =>
    selectShopCurrencies(state, { country, sharingId: orgId }),
  );

  const options = currencies.map(currency => {
    const isRepetitive = formatCurrency(currency).localeCompare(currency) === 0;

    return {
      label: isRepetitive
        ? currency
        : `${formatCurrency(currency)} ${currency}`,
      value: currency,
    };
  });

  const selectedOption = options.find(opt => opt.value === value);

  const isDisabled = disabled || loading;

  return (
    <Select
      className={className}
      name={name}
      options={options}
      value={selectedOption}
      onChange={onChange}
      isLoading={loading}
      isDisabled={isDisabled}
      isReadonly={!isDisabled && options.length <= 1}
    />
  );
}
